import React from 'react';
import { CheckboxField } from '@trp-beacon-ui-kit/react-controls';
import cn from 'classnames';
import { endOfMonth } from '../FundList/util';
import { isEmptyObject } from '../../core/util';
import { checkDuplicateFunds } from './util';
import styles from './style.css';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';

const ExistingFundsTable = ({
  funds,
  toggleFund,
  selectedFunds,
  setSelectedFunds,
  selectedFundsAgreementIds,
  newFundStatus,
  setNewFundStatus
}) => {
  return (
    <div className="existing-funds">
      <table>
        <thead>
          <tr className="table-header-row">
            <th className="fund-name-th">Fund Name</th>
            <th className="account-number-th">Account #</th>
            <th className="balance-amt-th">Balance as of {endOfMonth()}</th>
          </tr>
        </thead>

        {!isEmptyObject(funds) && (
          <tbody className="funds-table-body">
            {funds?.map(fund => {
              const isDuplicate = checkDuplicateFunds(
                fund.agreementID,
                fund.ticker,
                funds,
                selectedFunds
              );
              const isAgreementInEligible = !fund.eligibleForTransaction;
              const disabled = isDuplicate || isAgreementInEligible;
              return (
                <tr key={fund.ticker} className={cn('fund-row', { disabled })}>
                  <td className="fund-type-cell">
                    <CheckboxField
                      name={`checkbox ${fund.ticker}`}
                      data-name={generateGeneralTestID(
                        'ExistingFunds',
                        `${fund.ticker}`
                      )}
                      title={`${fund.shortName} (${fund.ticker})`}
                      disabled={disabled}
                      /* restores the user selection if landed on this screen  
                      via review screen or comes back from the previous screen */
                      defaultChecked={selectedFundsAgreementIds.includes(
                        fund?.agreementID
                      )}
                      onClick={() =>
                        toggleFund(fund, selectedFunds, setSelectedFunds)
                      }
                    />
                    <br />
                    {fund.accountType}
                  </td>
                  <td className="fund-account-number-cell">
                    {fund.agreementNumber}
                  </td>
                  <td className="fund-balance-cell">{fund.balanceAsOf}</td>
                </tr>
              );
            })}
            <tr className="new-fund-row">
              <td className="new-fund-cell" colSpan="100">
                <CheckboxField
                  className="add-new-fund"
                  data-name={generateGeneralTestID(
                    'ExistingFunds',
                    'AddNewFundsButton'
                  )}
                  name="new"
                  title="Add New Funds"
                  defaultChecked={newFundStatus}
                  onClick={() => setNewFundStatus(!newFundStatus)}
                />
              </td>
            </tr>
          </tbody>
        )}
      </table>
      <style jsx>{styles}</style>
    </div>
  );
};

export default ExistingFundsTable;
